import { text } from "d3";
import { createContext } from "react";
import { LANG, Translate } from "./models/common_model";

export const TestingVisualSearchParameterContext = createContext<[{[key: string]: string}, React.Dispatch<any>]>([{}, () => {}]);
export const DetailIdContext = createContext<any>(null);
export const LanguageContext = createContext<[Translate, LANG]>([text => Array.isArray(text) ? text.join('') : text, 'en']);


export const TestResultMissingPointsContext = createContext<[boolean, React.Dispatch<boolean>]>([false, ()=>{}]);
